import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { ToolsService } from 'src/app/services/tools.service';
import { MessageDialogComponent } from '../message-dialog/message-dialog.component';

@Component({
  selector: 'app-confirm-terms-and-condition',
  templateUrl: './confirm-terms-and-condition.component.html',
  styleUrls: ['./confirm-terms-and-condition.component.scss'],
})
export class ConfirmTermsAndConditionComponent {
  @Input() role!: number;
  @Input() data: any;
  @Input() full!: boolean;

  constructor(
    private termsModal: ModalController,
    private authService: AuthService,
    private toolService: ToolsService,
    private modalCtrl: ModalController
  ) {}
  tycUrl = 'https://tus-terminos.com';

  closeModal() {
    this.termsModal.dismiss();
  }

  acceptTerms() {
    // console.log('Términos aceptados');
    this.saveRolRequest(this.role);
  }

  viewTerms() {
    window.open(this.tycUrl, '_blank', 'noopener,noreferrer');
  }

  saveRolRequest(id: number) {
    this.authService.saveRol(id).subscribe({
      next: () => {
        this.openModal();
        //this.toolService.presentSucessToast('Rol asignado correctamente.'); // Mensaje de éxito
      },
      error: (error) => {
        console.error('Error al asignar el rol:', error);
        this.toolService.presentErrorToast(
          'Hubo un error al asignar el rol. Inténtalo de nuevo.'
        );
      },
    });
  }

  async openModal() {
    const modal = await this.modalCtrl.create({
      component: MessageDialogComponent,
      componentProps: { full: this.full },
      cssClass: this.full ? 'custom-modal' : 'custom-modal-dialog',
    });

    // modal.onDidDismiss().then((data) => {
    //   this.termsModal.dismiss(true);
    // });

    modal.onDidDismiss().then(() => {
      this.termsModal.dismiss({
        goToLogin: true,
      });
    });

    await modal.present();
  }
}
